import { Stack, Typography } from '@mui/material';

export type ObjectDetailsSection = {
  title: string;
  content: React.ReactNode;
};

type ObjectDetailsSectionsProps = {
  sections: ObjectDetailsSection[];
};

const sectionTitleSx = {
  pb: 0.5,
  borderBottom: 1,
  borderColor: 'brand',
};

const ObjectDetailsSections = ({ sections }: ObjectDetailsSectionsProps) => (
  <Stack gap={2}>
    {sections.map(section => (
      <Stack key={section.title} gap={1}>
        <Typography variant="subtitle1" color="brand" sx={sectionTitleSx}>
          {section.title}
        </Typography>
        {section.content}
      </Stack>
    ))}
  </Stack>
);

export default ObjectDetailsSections;
